<template>
  <div id="dashboard-analytics">
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/1 mb-base">
        <vx-card>
          <div class="vx-row flex-col-reverse md:flex-col-reverse sm:flex-row lg:flex-row">
          </div>
          <vs-divider class="my-6"></vs-divider>
          <vs-row>
            <vs-col type="flex" vs-justify="center" style="color: #f39c12" vs-align="center" vs-w="2">
              <vs-card  class="cardx" style="height:200px !important"><br><br><br><br>
                <center><h5> TOTALES:</h5> </center>
                <span><b style="font-size:25px !important"><center>{{TotalUti}}</center></b></span>
              </vs-card>
            </vs-col>
            <vs-col type="flex" vs-justify="center" style="color: #27ae60" vs-align="center" vs-w="2">
              <vs-card  class="cardx" style="height:200px !important"><br><br><br><br>
                <center><h5>ESTE MES:</h5> </center>
                <span><b style="font-size:25px !important"><center>{{esteMes}}</center></b></span>
              </vs-card>
            </vs-col>
            <vs-col type="flex" vs-justify="center" style="color: #c0392b" vs-align="center" vs-w="2">
              <vs-card  class="cardx" style="height:200px !important"><br><br><br><br>
                <center><h5>MES PASADO:</h5> </center>
                <span><b style="font-size:25px !important"><center>{{ultimoMes}}</center></b></span>
              </vs-card>
            </vs-col>
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="3">
              <vs-card  class="cardx" style="height:200px !important">
                <center><vue-apex-charts type="radialBar" height="200" :options="radialBarChart.chartOptions" :series="radialBarChart.series"></vue-apex-charts></center>
              </vs-card>
            </vs-col>
            <vs-col type="flex" vs-justify="center" style="color: #2980b9" vs-align="center" vs-w="3">
              <vs-card  class="cardx" style="height:200px !important"><br><br><br><br>
                <center><h5>Llevas <b>{{this.sigienteNivel}} </b> de <b>{{minimo_memb.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} VIVOCOINS </b>para recalificar en la categoría actual </h5></center>
              </vs-card>
            </vs-col>
          </vs-row>
          <div class="vx-row" style="padding-top:20px;">
            <div class="vx-col w-1/12 mb-12">
            </div>
            <div class="vx-col w-10/12 mb-12">
              <div class="carousel-example">
                <swiper :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl">
                    <swiper-slide v-for="(item, index) in Baners" :key="index">
                      <div v-if="item.tipo==1">
                        <a :href="'mailto:'+item.link_email" target="_blank">
                          <img :src=getPathPromo(item.imagen) class="responsive" alt="banner"/> 
                        </a>
                      </div>
                      <div v-else>
                        <a :href='item.link_email' target="_blank">
                          <img :src=getPathPromo(item.imagen) class="responsive" alt="banner"/> 
                        </a>
                      </div>
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
              </div>
            </div>
            <div class="vx-col w-1/12 mb-12">
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<style type="text/css">
  .vs-alert .vs-icon {
    font-size: 40px;
  }
  .vs-alert div {
    padding-left: 30px;
  }
</style>
<script>
function generateData (baseval, count, yrange) {
  let i = 0
  const series = []
  while (i < count) {
    //var x =Math.floor(Math.random() * (750 - 1 + 1)) + 1;;
    const y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min
    const z = Math.floor(Math.random() * (75 - 15 + 1)) + 15

    series.push([baseval, y, z])
    baseval += 86400000
    i++
  }
  return series
}
function generateDataHeatMap (count, yrange) {
  let i = 0
  const series = []
  while (i < count) {
    const x = `w${(i + 1).toString()}`
    const y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min

    series.push({
      x,
      y
    })
    i++
  }
  return series
}
const themeColors = ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'];
import VueApexCharts from 'vue-apexcharts'
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data () {
    return {
      TotalUti:0,
      esteMes:0,
      sigienteNivel:0,
      ultimoMes:0,
      porcentaje_memb:0,
      minimo_memb:0,
      tipo_memb:0,
      Baners: "",
      swiperOption: {
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: {
          delay: 3500,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      radialBarChart: {
        series: [0],
        chartOptions: {
          colors: themeColors,
          plotOptions: {
            radialBar: {
              hollow: {
                  margin: 5,
                  size: '45%',
                  imageWidth: 150,
                  imageHeight: 150,
                  imageOffsetX: 0,
                  imageOffsetY: 0,
                  imageClipped: false,
                  position: 'front',
                  dropShadow: {
                    enabled: false,
                    top: 10,
                    left: 0,
                    blur: 3,
                    opacity: 0.5
                  }
              },
              dataLabels: {
                name: {
                  fontSize: '16px'
                },
                value: {
                  fontSize: '16px'
                },
                total: {
                  show: true,
                  label: 'Completado',
                  formatter (valor) {
                    return valor.config.series[0]+'%';
                  }
                }
              }
            }
          },
        }
      },
    }
  },
  components: {
    swiper,
    swiperSlide,
    VueApexCharts
  },
  methods:{ 
    init(){
      this.openLoading();
      this.validacion();
    },
    openLoading(){
      this.$vs.loading({type:'corners'});
    },
    closeLoading(){
      this.$vs.loading.close();
    },
    validacion(){
      this.$http.post('Empresas','consultarInfoPerfil',[],(data)=>{
        if(data.empresa == '' || data.rfc==''){
          this.$router.push('/perfil').catch(() => {});
          this.$swal.fire(
            'Perfil',
            'Llena tu perfil antes de continuar',
            'warning'
          );
        }else{
          this.getBaners();
           this.$http.post('Empresas','GetPuntosHOME',[],(data)=>{
            this.TotalUti=data.TotalUti.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            this.esteMes = data.esteMes.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); 
            this.sigienteNivel = data.sigienteNivel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            this.ultimoMes=data.ultimoMes.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            this.porcentaje_memb = 0;
            this.minimo_memb = data.mincoins;
            this.TotalAno=data.TotalAno.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            if(data.TotalAno>0)
              this.porcentaje_memb = parseInt((data.TotalAno/data.mincoins) * 100);
              if(this.porcentaje_memb>100)
                this.porcentaje_memb=100;
              this.radialBarChart.series = [this.porcentaje_memb];
          });
        }
        this.closeLoading();
      });
    },
    getPathPromo(img){
         return this.$http.getImgPathPromo(img);
    },
    getBaners(){
      this.$http.post('Promocion','Activos',[],(data)=>{
          this.Baners = data;
      });
    }
  },
  mounted() {
    this.init();
  },
}
</script>
<style lang="scss">
  /*! rtl:begin:ignore */
  #dashboard-analytics {
    .greet-user{
      position: relative;
      .decore-left{
        position: absolute;
        left:0;
        top: 0;
      }
      .decore-right{
        position: absolute;
        right:0;
        top: 0;
      }
    }
    @media(max-width: 576px) {
      .decore-left, .decore-right{
        width: 140px;
      }
    }
  }
  /*! rtl:end:ignore */
</style>